import type { Template, TemplatePart } from '../../types';

const AVAIL = ['in_stock', 'order_required', 'backordered', 'discontinued'];
const avail = (a: any): TemplatePart['availability'] => (AVAIL.includes(a) ? a : 'in_stock');

function vehicleFields(vehicle?: { make?: string; model?: string }, vehicleYears?: number[]) {
  if (vehicle && vehicle.make && vehicle.model && vehicleYears && vehicleYears.length) {
    return { vehicle_years: vehicleYears.join(','), vehicle_make: vehicle.make, vehicle_model: vehicle.model };
  }
  return {};
}

export function buildPartTemplate(input: {
  name: string;
  part: any;
  vehicle?: { make?: string; model?: string };
  vehicleYears?: number[];
}): Omit<Template, 'id' | 'usage_count'> {
  const p = input.part || {};
  return {
    type: 'part',
    name: input.name,
    part_number: p.part_number ?? null,
    description: p.description ?? null,
    supplier: p.supplier ?? null,
    ...vehicleFields(input.vehicle, input.vehicleYears),
    payload: {
      unit_price: p.unit_price ?? 0,
      cost: p.cost ?? null,
      markup_preset_id: p.markup_preset_id ?? null,
      markup_percentage: p.markup_percentage ?? null,
      discount_percentage: p.discount_percentage ?? null,
      discount_amount: p.discount_amount ?? null,
      availability: avail(p.availability),
      notes: p.notes ?? null,
    },
  };
}

export function buildLineTemplate(input: {
  name: string;
  line: any;
  vehicle?: { make?: string; model?: string };
  vehicleYears?: number[];
}): Omit<Template, 'id' | 'usage_count'> {
  const l = input.line || {};
  const parts: TemplatePart[] = (l.parts || []).map((p: any) => ({
    part_number: p.part_number,
    description: p.description,
    quantity: p.quantity ?? 1,
    unit_price: p.unit_price ?? 0,
    cost: p.cost ?? null,
    markup_preset_id: p.markup_preset_id ?? null,
    markup_percentage: p.markup_percentage ?? null,
    discount_percentage: p.discount_percentage ?? 0,
    discount_amount: p.discount_amount ?? 0,
    availability: avail(p.availability),
    supplier: p.supplier,
  }));
  return {
    type: 'line',
    name: input.name,
    category: l.category ?? null,
    description: l.description ?? null,
    ...vehicleFields(input.vehicle, input.vehicleYears),
    payload: {
      quantity: l.quantity ?? 1,
      labor_hours: l.labor_hours ?? null,
      hourly_rate: l.hourly_rate ?? null,
      labor_rate_id: l.labor_rate_id ?? null,
      labor_discount_percentage: l.labor_discount_percentage ?? null,
      labor_discount_amount: l.labor_discount_amount ?? null,
      notes: l.notes ?? null,
      parts,
    },
  };
}
